export default "__VITE_ASSET__BqY1ynb2__"